"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.USE_MOCKS = exports.USER_LOCALE = exports.USER_LANGUAGE_CODE = exports.USER_LANGUAGES = exports.USER_COUNTRY_CODE = exports.LOCAL_PORT = exports.IS_LOCAL_STORYBOOK = exports.CURRENT_PORT = exports.CURRENT_DOMAIN = void 0;
const CURRENT_DOMAIN = exports.CURRENT_DOMAIN = document.domain;
const CURRENT_PORT = exports.CURRENT_PORT = document.location.port;
const LOCAL_PORT = exports.LOCAL_PORT = '8080';
const IS_LOCAL_STORYBOOK = exports.IS_LOCAL_STORYBOOK = CURRENT_DOMAIN === 'localhost' && CURRENT_PORT !== LOCAL_PORT;
const USE_MOCKS = exports.USE_MOCKS = IS_LOCAL_STORYBOOK || false; // Set to true to use mock data where available

const USER_LANGUAGES = exports.USER_LANGUAGES = navigator && navigator.languages || ['en-AU'];
const USER_LOCALE = exports.USER_LOCALE = USER_LANGUAGES[0];
const USER_LANGUAGE_CODE = exports.USER_LANGUAGE_CODE = USER_LOCALE.substring(0, 2);
const USER_COUNTRY_CODE = exports.USER_COUNTRY_CODE = USER_LOCALE.substring(3);
var _default = exports.default = {
  CURRENT_DOMAIN,
  CURRENT_PORT,
  USER_LANGUAGES,
  USER_LOCALE,
  USER_LANGUAGE_CODE,
  USER_COUNTRY_CODE
};